export const SERVER = process.env.REACT_APP_MCS_SERVER;
export const API = `${SERVER}/api`;

export const wsUrl = (token) => `${SERVER.replace(/^http/, "ws")}/api/ws?token=${token}`;

export const mediaUrl = (p) => {
  if (!p) return "";
  if (p.startsWith("http")) return p;
  return `${SERVER}${p}`;
};

// Best thumbnail for a video: its thumbnail, else the HLS poster frame.
export const thumbUrl = (v) => {
  if (!v) return "";
  const t = mediaUrl(v.thumbnail || v.thumbnailUrl || v.cover);
  if (t) return t;
  const stream = mediaUrl(v.webVideoUrl || v.videoUrl);
  if (stream && stream.includes(".m3u8")) return stream.replace(/\.m3u8(\?.*)?$/, ".jpg");
  return "";
};

export const fmtNum = (n) => {
  if (n == null) return "0";
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}K`;
  return String(n);
};

export const fmtDur = (s) => {
  if (!s && s !== 0) return "";
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${String(sec).padStart(2, "0")}`;
};

export const fmtSize = (b) => {
  if (b == null) return "";
  if (b >= 1e6) return `${(b / 1e6).toFixed(1)} MB`;
  if (b >= 1e3) return `${(b / 1e3).toFixed(0)} KB`;
  return `${b} B`;
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 30) return `${Math.floor(diff / 86400)}d ago`;
  return new Date(iso).toLocaleDateString();
};
